const SAVE_SELECTED_ITEMS = 'SAVE_SELECTED_ITEMS';
const SAVE_SCROLL_POSITION = 'SAVE_SCROLL_POSITION';

export default {
  /** 選択データ保存 */
  SAVE_SELECTED_ITEMS,

  /** スクロール位置保存 */
  SAVE_SCROLL_POSITION,
};
